import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d8840e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0d8840e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8840e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8840e8')) {
      api.createRecord('0d8840e8', component.options)
    } else {
      api.reload('0d8840e8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0d8840e8&scoped=true", function () {
      api.rerender('0d8840e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceManage/customerManage/invoiceRecord/index.vue"
export default component.exports